
                  export default function (Component) {
                      Component.__source = "library/layouts/VabLayoutHorizontal/index.vue"
                  }
              